import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Aux from '../../../components/Hoc/Aux';
import DocSearch from '../../../components/DocSearch/DocSearch.jsx';
import Testimonials from '../../../components/Testimonials/Testimonials';
import Reasons from '../../../components/Reasons/ReasonsGovernment';

class General extends Component {
  componentDidMount () {
    this.props.toggleInQuiz(false);
    this.props.toggleInResults(false);
    this.props.setStep(1);

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'GAEvent',
      'eventCategory': 'View',
      'eventAction': 'Landing',
      'eventLabel': 'Plans - Government Programs',
      'eventValue': undefined
    });
  }

  render () {
    return (
      <Aux>
        <Reasons />
        <DocSearch search='https://findadoc.cdphp.com/?PlanType=New%20York%20State%20of%20Health%20-%20Individuals%20&%20Families' />
        <Testimonials heading='&ldquo;CDPHP treats you like someone they know and care about.&rdquo;' slides='consumer'>
          <p className='text-center'><Link to='/find-a-plan/' className='btn alt lg'>Find a Plan</Link></p>
        </Testimonials>
      </Aux>
    );
  }
}

General.propTypes = { // validate props expected
};

export default General;